/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import { HYDRATE_DASHBOARD } from '../actions/hydrate';

export const UPDATE_CHART_TIME_GRANULARITY = 'UPDATE_CHART_TIME_GRANULARITY';

export function updateChartTimeGranularity(chartId, timeGranularity) {
  return {
    type: UPDATE_CHART_TIME_GRANULARITY,
    chartId,
    timeGranularity,
  };
}

export default function chartStateReducer(state = {}, action) {
  const actionHandlers = {
    [HYDRATE_DASHBOARD]() {
      return { ...state, ...action.data.chartState };
    },
    [UPDATE_CHART_TIME_GRANULARITY]() {
      return {
        ...state,
        [action.chartId]: {
          ...state[action.chartId],
          timeGranularity: action.timeGranularity,
        },
      };
    },
  };

  if (action.type in actionHandlers) {
    return actionHandlers[action.type]();
  }
  return state;
}
